import Vue from 'vue'
import { noRiskUrlList } from '~/assets/js/domain.js'

// 是否为国际版（true国际版、false国内版）
export const isGlobal = (process.env.isGlobal > 0)

// 公用方法
export const currProject = {
  // 当前语言
  currLangCode () {
    return this.$store?.state?.locale
  },
  // 判断当前语言是否为中文
  isChinese () {
    return ['zh-cn', 'zh', 'zh-hk', 'zh-tw'].includes(this.currLangCode())
  },
  // 判断当前语言是否为简体中文
  isCn () {
    return ['zh-cn'].includes(this.currLangCode())
  },
  // 判断当前语言是否为繁体中文
  isHK () {
    return ['zh', 'zh-hk', 'zh-tw'].includes(this.currLangCode())
  },
  // 判断当前语言是否为阿拉伯语
  isAr () {
    return ['ar'].includes(this.currLangCode())
  },
  // 特殊域名处理，不展示风险提示（红框）逻辑
  filterSpecial () {
    return noRiskUrlList.includes(this.$store.state?.fullHost)
  },
  // 数字千分位展示
  num2CurrencyNo (value = 0) {
    if (!value) return 0
    value = Number(value) || 0
    const intPart = Math.trunc(value) // 获取整数部分
    const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 整数部分处理，增加,
    let floatPart = '' // 预定义小数部分
    const valueArray = value.toString().split('.') // 将数值截取为小数部分和整数部分
    if (valueArray.length == 2) { // 有小数部分
      floatPart = valueArray[1].toString() // 取得小数部分
      return intPartFormat + '.' + floatPart
    }
    return intPartFormat + floatPart
  },
  // 数据由WikiFX Data提供
  providerTxt () {
    const translate = this.$t('19219')?.split('{0}')
    return [translate[0] || '', translate[1] || '']
  },
  // 是否为“红涨绿跌”的国家
  isRedUp () {
    return ['156', '158', '344', '446', '392'].includes(String(this.$store.state?.countryCode))
  },
  // 涨跌（1绿色、-1红色、0灰色）
  riseFn (value = 0) {
    return this.isRedUp() ? (value > 0 ? -1 : (value < 0 ? 1 : 0)) : (value > 0 ? 1 : (value < 0 ? -1 : 0))
  },
  // 不四舍五入保留小数 num 需要格式化的数据 decimal 保留小数个数
  formatDecimal (num, decimal) {
    num = num.toString()
    const index = num.indexOf('.')
    if (index !== -1) num = num.substring(0, decimal + index + 1)
    else num = num.substring(0)
    return parseFloat(num).toFixed(decimal)
  },
  // 设置head标签头部相关参数
  setCanonical () {
    const [otherArr, completeUrl] = [[], 'https://' + this.$store?.state?.fullHost + (this.$route?.fullPath || '')]
    const linkLang = [
      { before: 'en', after: 'x-default' },
      { before: 'en', after: 'en' },
      { before: 'zh-cn', after: 'zh-Hans' },
      { before: 'zh', after: 'zh-Hant' },
      { before: 'ja', after: 'ja' },
      { before: 'id', after: 'id' },
      { before: 'vi', after: 'vi' },
      { before: 'ru', after: 'ru' },
      { before: 'es', after: 'es' },
      { before: 'th', after: 'th' },
      { before: 'fil', after: 'tl' },
      { before: 'fr', after: 'fr' },
      { before: 'pt', after: 'pt' },
      { before: 'de', after: 'de' },
      { before: 'hi', after: 'hi' },
      { before: 'tr', after: 'tr' },
      { before: 'ar', after: 'ar' }
    ]
    if (isGlobal) {
      linkLang?.forEach((item) => {
        otherArr.push({ rel: 'alternate', hreflang: item.after, href: completeUrl?.replace(this.currLangCode(), item.before) })
      })
    }
    return [
      { rel: 'canonical', href: completeUrl },
      ...otherArr
    ]
  }
}

Object.keys(currProject).forEach((item) => {
  Vue.prototype[item] = currProject[item]
})
